export default "__VITE_ASSET__59e75702__"